import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LockerVisorPage } from './locker-visor.page';
import { RouterModule } from '@angular/router';
import { PipesModule } from 'app/pipes/pipes.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    RouterModule
  ],
  declarations: [LockerVisorPage]
})
export class LockerVisorPageModule {}
